import { apiClient } from './api';

export interface EmailTemplate {
  _id: string;
  name: string;
  code: string;
  subject: string;
  content: string;
  state: number;
  created_at: string;
  updated_at: string;
  created_by?: string;
  updated_by?: string;
}

export interface CreateEmailTemplateDto {
  name: string;
  code: string;
  subject: string;
  content: string;
  state?: number;
}

export interface UpdateEmailTemplateDto {
  name?: string;
  code?: string;
  subject?: string;
  content?: string;
  state?: number;
}

export interface QueryEmailTemplateDto {
  page?: number;
  limit?: number;
  search?: string;
  state?: number;
  sort?: string;
  order?: 'asc' | 'desc';
}

export interface EmailTemplatesResponse {
  data: EmailTemplate[];
  meta: {
    page: number;
    limit: number;
    total: number;
    total_pages: number;
  };
}

export interface SendTestEmailDto {
  recipient_email: string;
  subject: string;
  content: string;
}

export const emailTemplateService = {
  getAll: async (filters: QueryEmailTemplateDto = {}): Promise<EmailTemplatesResponse> => {
    const response = await apiClient.get('/email-templates', { params: filters });
    return { data: response.data.data as EmailTemplate[], meta: response.data.meta };
  },

  getById: async (id: string): Promise<EmailTemplate> => {
    const response = await apiClient.get(`/email-templates/${id}`);
    return response.data.data;
  },

  create: async (data: CreateEmailTemplateDto): Promise<EmailTemplate> => {
    const response = await apiClient.post('/email-templates', data);
    return response.data.data;
  },

  update: async (id: string, data: UpdateEmailTemplateDto): Promise<EmailTemplate> => {
    const response = await apiClient.put(`/email-templates/${id}`, data);
    return response.data.data;
  },

  deleteMany: async (ids: string[]): Promise<void> => {
    await apiClient.delete('/email-templates', { data: { ids } });
  },

  clone: async (id: string): Promise<EmailTemplate> => {
    const response = await apiClient.post(`/email-templates/clone/${id}`);
    return response.data.data;
  },

  sendTest: async (data: SendTestEmailDto): Promise<{ message: string }> => {
    const response = await apiClient.post('/email-templates/send-test', data);
    return response.data.data;
  },
};

export default emailTemplateService;
